import { EmailPasswordSignUp } from "../../components/email-password/sign-up/EmailPasswordSignUp";
import { PageContainer } from "../../components/page-container/PageContainer";

export const SignUp = () => (
  <PageContainer floatTop backButton>
    <EmailPasswordSignUp />
  </PageContainer>
);
